import { mockBuilder } from '../utils/builderHelper.es.js';
import { PromolinkStats } from './PromolinkStats.es.js';

/** @module Mocks */ /** typedoc */
function aPromolinkStats() {
    return mockBuilder(new PromolinkStats()).withPageViews(5000).withUniqueVisitors(750);
}

export { aPromolinkStats };
